<template>
    <EmployeePage>
        <BreachTable :rows="breaches" :loading="loading" class="card" />
    </EmployeePage>
</template>

<script>
import { TeamStoreNamespacedTypes } from "@/store/modules/team";

import { getProperty } from "@/utils/object";

import BreachTable from "@/components/display/breach/BreachTable";
import EmployeePage from "@/components/layout/EmployeePage";

export default {
    name: "EmployeeSingle",
    components: {
        EmployeePage,
        BreachTable,
    },
    computed: {
        /**
         * The loading state for the API request.
         * @type {Boolean}
         */
        loading() {
            return this.$store.getters[
                TeamStoreNamespacedTypes.getters.LOADING
            ]();
        },

        /**
         * @type {Object}
         */
        employee() {
            return this.$store.getters[
                TeamStoreNamespacedTypes.getters.EMPLOYEE
            ]();
        },

        /**
         * @type {Array}
         */
        breaches() {
            return getProperty(this.employee, "breaches", []);
        },
    },
    mounted() {
        this.$store.dispatch(
            TeamStoreNamespacedTypes.actions.GET_EMPLOYEE,
            this.$route.params.id
        );
    },
};
</script>
